// Import model
import { Lead2Condition } from '../models/Lead2Condition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { Lead2IndexedFields } from '../models/Lead2IndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { Lead2IndexedFieldsSerializer } from './Lead2IndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Lead2Condition - handles JSON serialization and deserialization with type validation
 */
export class Lead2ConditionSerializer {
  /**
   * Deserializes a JSON string into a Lead2Condition instance
   */
  static deserialize(json: string): Lead2Condition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Lead2Condition instance
   */
  static fromObject(obj: any): Lead2Condition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Lead2Condition');
    }


    const instance: Lead2Condition = {
      fieldName: obj['fieldName'] as Lead2IndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Lead2Condition instances
   */
  static deserializeArray(json: string): Lead2Condition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Lead2Condition instance to a JSON string
   */
  static serialize(instance: Lead2Condition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Lead2Condition instance to a plain object
   */
  static toObject(instance: Lead2Condition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of Lead2Condition instances to a JSON string
   */
  static serializeArray(instances: Lead2Condition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
